export const getExpandedKeys = (treeData, selectedKey) => {
  let expandedKeys = [];

  const findNode = (nodes, key) => {
    if (!Array.isArray(nodes)) {
      console.warn("getExpandedKeys error: treeData is not an array:", nodes);
      return false;
    }

    for (let node of nodes) {
      if (node.key === key) {
        return true; // found target
      }
      if (node.children && node.children.length > 0) {
        if (findNode(node.children, key)) {
          expandedKeys.push(node.key); // add parent folder
          return true;
        }
      }
    }
    return false;
  };

  const found = findNode(treeData, selectedKey);

  if (!found) {
    console.warn(
      `getExpandedKeys error: Key '${selectedKey}' not found in treeData.`
    );
  }

  return expandedKeys;
};
